var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"board-banner d-flex align-center justify-center"},[_c('span',{staticClass:"board-banner__title"},[_vm._v("กระดานข่าว")])])
}]

export { render, staticRenderFns }